import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import {Table, Card, FormControl, Form, Col, Row, Button, Modal, InputGroup, Spinner, Tabs, Tab} from 'react-bootstrap';
import Cards from 'react-credit-cards';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import React, {useState, useEffect} from 'react';
import NumberFormat from 'react-number-format';
import {toast} from 'react-toastify';
import Helmet from 'react-helmet';
import './App.css';
import {InfoTwoTone} from "@mui/icons-material";
import {useCookies} from 'react-cookie';
import Login from './Login';
import InfoDialog from "./ui/dialog/InfoDialog";
import TooltipDialog from "./ui/dialog/TooltipDialog";
import WarningDialog from "./ui/dialog/WarningDialog";
import Tooltip from '@mui/material/Tooltip';
import EtcDataGrid from "./ui/grid/EtcDataGrid";
import DetailListDialog from "./ui/dialog/DetailListDialog";
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import SendIcon from '@mui/icons-material/Send';

import moment from "moment";

import {ONLY_NUMBER_REGEX, EMAIL_VALIDATE, formatCvc, formatExpiry, formatCardNumber} from './formatter'
import {
    overFlowDosyaCountMessage,
    calculateUrl,
    errorMessage,
    connectionErrorMessage,
    tenantInfoUrl,
    helmetTitle,
    defaultRequestDto,
    defaultViewDto,
    maxCount,
    selectSubscriptionBillingTypeMessage,
    sendDiscountCouponCodeUrl,
    payUrl,
    warningTenantPropertiesCountId,
    warningTenantPropertiesCountMessage,
    getPaymentHistoryUrl,
    testSuccessPaymentUrl, testErrorPaymentUrl, adminManagementCheckUrl
} from './data.js';
import {
    minimumDosyaCount, minimumDosyaCountId,
    minimumFeatureTypeSelectionMessage, minimumFeatureTypeSelectionMessageId,
    minimumTokenCount, minimumTokenCountId,
    minimumUserCount, minimumUserCountId, overFlowDosyaCountMessageId
} from './data';
import {GridRenderCellParams} from "@mui/x-data-grid";
import AhtapotSubscription from "./ahtapot/AhtapotSubscription";
import HeaderPart from "./ui/header/HeaderPart";
import MainHeaderPart from "./ui/header/MainHeaderPart";
import UgyPlansYearly from "./ui/UgyPlansYearly";
import {debugLog} from "./debug";
import PaymentTestSimulationPanel from "./ui/PaymentTestSimulationPanel";
import OnlinePaymentDisabledNotice, {
    ONLINE_PAYMENT_ENABLED,
    disabledPaymentButtonStyle
} from "./ui/OnlinePaymentDisabledNotice";


function SubscriptionWithPayment({setCookie, removeCookie}) {
    const [cookies] = useCookies(['subscriptionToken']);
    const [actionCount, setActionCount] = useState(0);
    const [requestDto, setRequestDto] = useState(defaultRequestDto);
    const [subscriptionFeatureTypeDtoList, setSubscriptionFeatureTypeDtoList] = useState([]);
    const [selectAllFeatures, setSelectAllFeatures] = useState(false);
    const [selectedSubscriptionFeatureTypeDtoList, setSelectedSubscriptionFeatureTypeDtoList] = useState([]);
    const [viewDto, setViewDto] = useState(defaultViewDto);
    const [featureCount, setFeatureCount] = useState(0);
    const [presaleMaxCount, setPresaleMaxCount] = useState(0);
    const [selectedSubscriptionBillingTypeEnumValue, setSelectedSubscriptionBillingTypeEnumValue] = useState('');
    const [oldSubscriberUser, setOldSubscriberUser] = useState(false);
    const [defaultTenantProperties, setDefaultTenantProperties] = useState(null);
    const [tenantSubscriptionViewDto, setTenantSubscriptionViewDto] = useState({});
    const [modalShow, setModalShow] = useState(false);
    const [loginShow, setLoginShow] = useState(false);
    const [secureScreenShow, setSecureScreenShow] = useState(false);
    const [secureUrl, setSecureUrl] = useState('');
    const [paymentProcessing, setPaymentProcessing] = useState(false);
    const [creditCardValidated, setCreditCardValidated] = useState(false);
    const [tabKey, setTabKey] = useState('ahtapot');
    const [cardState, setCardState] = useState({
        cvc: '',
        expiry: '',
        focus: '',
        name: '',
        number: '',
        email: '',
        gsm: ''
    });

    const [validState, setValidState] = useState({
        cvc: false,
        expiry: false,
        name: false,
        number: false,
        email: false,
        gsm: false
    });
    const [ready, setReady] = useState(false);
    const [toolTipText, setToolTipText] = useState("");
    const [toolTipTitle, setToolTipTitle] = useState("");
    const [openTooltipModal, setOpenTooltipModal] = React.useState(false);
    const [validSourceSystemEntegrationOpenDialog, setValidSourceSystemEntegrationOpenDialog] = React.useState(false);
    const [infoSourceSystemEntegrationOpenDialog, setInfoSourceSystemEntegrationOpenDialog] = React.useState(false);
    const [paymentHistoryData, setPaymentHistoryData] = useState([]);
    const [openDetailListDialogModal, setOpenDetailListDialogModal] = React.useState(false);
    const [enableDiscountCodeSuccess, setEnableDiscountCodeSuccess] = React.useState(false);
    const [discountCouponCodeValue, setDiscountCouponCodeValue] = React.useState("");
    const [discountCouponCodeDto, setDiscountCouponCodeDto] = React.useState(null);

    const [hasAdminManagement, setHasAdminManagement] = React.useState(false);
    const [payPaymentId, setPayPaymentId] = React.useState('');
    const [testProcessing, setTestProcessing] = React.useState(false);

    const currencyFormatter = new Intl.NumberFormat('tr-TR', {
        style: 'currency',
        currency: 'TRY',
    });

    const sendDiscountCouponCode = () => {
        fetch(sendDiscountCouponCodeUrl,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'ApiAuthorization': 'Bearer '.concat(cookies.subscriptionToken)
                },
                body: JSON.stringify({"code" : discountCouponCodeValue, "type" : "UGY"})
            })
            .then(res => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error(errorMessage);
                }
            })
            .then((data) => {
                if (!data) {
                    return;
                }
                setEnableDiscountCodeSuccess(true);
                let requestTenantSubscriptionViewDto ={...tenantSubscriptionViewDto,
                    openUyapDosyaCount: requestDto.openUyapDosyaCount,
                    tokenCount: requestDto.tokenCount,
                    userCount: requestDto.userCount,
                };
                setDiscountCouponCodeDto({...data, "tenantSubscriptionViewDto" : requestTenantSubscriptionViewDto});
                getTenantInfo({...data, "tenantSubscriptionViewDto" : requestTenantSubscriptionViewDto});
            }, (error) => {
                if (error) {
                    toast.error("Geçersiz Kod", {
                        position: toast.POSITION.TOP_CENTER
                    });
                }
            });
    };

    const onChangeDiscountCouponCodeInput = (item) => {
        setDiscountCouponCodeValue(item.target.value);
    };

    const handleOpenTooltipModal = (item) => {
        if (item && item.tooltip) {
            setToolTipTitle(item.name);
            setToolTipText(item.tooltip);
            setOpenTooltipModal(true);
        }
    };

    const handleCloseTooltipModal = () => {
        setOpenTooltipModal(false);
    };

    const handleValidSourceSystemEntegrationOpenDialog = () => {
        setValidSourceSystemEntegrationOpenDialog(true);
    };

    const handleValidSourceSystemEntegrationCloseDialog = () => {
        setValidSourceSystemEntegrationOpenDialog(false);
    };

    const handleValidSourceSystemEntegrationAcceptDialog = () => {
        setValidSourceSystemEntegrationOpenDialog(false);
        openPaymentModal();
    };


    const handleInfoSourceSystemEntegrationOpenDialog = () => {
        setInfoSourceSystemEntegrationOpenDialog(true);
    };

    const handleInfoSourceSystemEntegrationCloseDialog = () => {
        setInfoSourceSystemEntegrationOpenDialog(false);
    };

    const handleInfoSourceSystemEntegrationAcceptDialog = () => {
        setInfoSourceSystemEntegrationOpenDialog(false);
        openPaymentModal();
    };

    const paymentHistoryColumns = [
        {
            field: 'subscriptionBillingTypeEnumValue',
            headerName: 'Abonelik Tipi',
            headerAlign: 'center',
            headerClassName: 'cell-header',
            cellClassName: 'cell-data',
            width: 160
        },
        {
            field: 'validIntervalBeginDateTime',
            type: 'dateTime',
            headerName: 'Abonelik Başlangıç Tarihi',
            headerAlign: 'center',
            headerClassName: 'cell-header',
            cellClassName: 'cell-data',
            width: 220
        },
        {
            field: 'validIntervalEndDateTime',
            type: 'dateTime',
            headerName: 'Abonelik Bitiş Tarihi',
            headerAlign: 'center',
            headerClassName: 'cell-header',
            cellClassName: 'cell-data',
            width: 200
        },
        {
            field: 'lastModifiedDateTime',
            type: 'dateTime',
            headerName: 'Son Değişiklik Tarihi',
            headerAlign: 'center',
            headerClassName: 'cell-header',
            cellClassName: 'cell-data',
            width: 180
        },
        {
            field: 'paymentAmountWithCommission',
            headerName: 'Ödenen Ücret',
            headerAlign: 'center',
            headerClassName: 'cell-header',
            cellClassName: 'cell-data',
            valueFormatter: ({ value }) => (value ? currencyFormatter.format(Number(value)) : null),
            width: 160
        },
        {
            field: 'installmentIndex',
            headerName: 'Taksit Sayısı',
            headerAlign: 'center',
            headerClassName: 'cell-header',
            cellClassName: 'cell-data',
            renderCell: (params: GridRenderCellParams) => (
                <strong>
                    {params.value > 1 ? (params.value) : "Tek Çekim"}
                </strong>
            ),
            width: 150
        },
        {
            field: 'installmentAmount',
            headerName: 'Taksit Tutarı',
            headerAlign: 'center',
            headerClassName: 'cell-header',
            cellClassName: 'cell-data',
            valueFormatter: ({ value }) => (value ? currencyFormatter.format(Number(value)) : null),
            width: 150
        },
        {
            field: 'bankCommissionAmount',
            headerName: 'Banka Kom. Tutarı',
            headerAlign: 'center',
            headerClassName: 'cell-header',
            cellClassName: 'cell-data',
            valueFormatter: ({ value }) => (value ? currencyFormatter.format(Number(value)) : null),
            width: 150
        },
        {
            field: 'discountCouponName',
            headerName: 'Uygulanan Kampanya',
            headerAlign: 'center',
            headerClassName: 'cell-header',
            cellClassName: 'cell-data',
            width: 150
        },
        {
            field: 'featureCount',
            headerName: 'Özellik Sayısı',
            headerAlign: 'center',
            headerClassName: 'cell-header',
            cellClassName: 'cell-data',
            width: 120
        },
        {
            field: 'userCount',
            headerName: 'Kullanıcı Sayısı',
            headerAlign: 'center',
            headerClassName: 'cell-header',
            cellClassName: 'cell-data',
            width: 140
        },
        {
            field: 'tokenCount',
            headerName: 'Token Sayısı',
            headerAlign: 'center',
            headerClassName: 'cell-header',
            cellClassName: 'cell-data',
            width: 140
        },
        {
            field: 'purchasedReferenceCode',
            headerName: 'Satın Alınan Referans Kodu',
            headerAlign: 'center',
            headerClassName: 'cell-header',
            cellClassName: 'cell-data',
            width: 180
        },
        {
            field: 'referenceTenant',
            headerName: 'Kampanya İlişkili Hukuk Bürosu',
            headerAlign: 'center',
            headerClassName: 'cell-header',
            cellClassName: 'cell-data',
            width: 180
        },
        {
            field: 'openUyapDosyaCount',
            headerName: 'Açık Dosya Sayısı',
            headerAlign: 'center',
            headerClassName: 'cell-header',
            cellClassName: 'cell-data',
            width: 170
        },
        {
            field: 'activeDosyaCount',
            headerName: 'İşlem Yapılan Dosya Sayısı',
            headerAlign: 'center',
            headerClassName: 'cell-header',
            cellClassName: 'cell-data',
            width: 220
        },
        {
            field: 'lastUpdatedBy',
            headerName: 'Değişikliği Yapan Kullanıcı',
            headerAlign: 'center',
            headerClassName: 'cell-header',
            cellClassName: 'cell-data',
            width: 220
        },
        {
            field: 'status',
            headerName: 'Abonelik Durumu',
            headerAlign: 'center',
            headerClassName: 'cell-header',
            cellClassName: 'cell-data',
            renderCell: (params: GridRenderCellParams) => (
                <strong style={{color:(params.value === "Aktif" ? 'GREEN' : "RED")}}>
                    {(params.value)}
                </strong>
            ),
            width: 140
        },
        {
            field: 'paymentStatus',
            headerName: 'Ödeme Durumu',
            headerAlign: 'center',
            headerClassName: 'cell-header',
            cellClassName: 'cell-data',
            renderCell: (params: GridRenderCellParams) => (
                <strong style={{color:(!params.row?.paymentAmount ? "BLUE" : params.value === "SUCCESS" ? 'GREEN' : "RED")}}>
                    {!params.row?.paymentAmount ? "Ödemesiz İşlem" : params.value === "SUCCESS" ? "Başarılı" : "Hatalı"}
                </strong>
            ),
            width: 140
        },
        {
            field: 'paymentRemark',
            headerName: 'Ödeme Açıklama',
            headerAlign: 'left',
            headerClassName: 'cell-header',
            cellClassName: 'cell-data',
            width: 400,
            renderCell: (params) => (
                <Tooltip
                    title={<div style={{ fontSize: '14px', padding: '8px' }}>{params.value || ''}</div>}
                    arrow
                    placement="top"
                    enterDelay={200}
                    componentsProps={{
                        tooltip: {
                            sx: {
                                maxWidth: '600px',
                                bgcolor: 'white',
                                color: 'black',
                                border: '1px solid #ccc',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                '& .MuiTooltip-arrow': {
                                    color: 'white',
                                    '&::before': {
                                        border: '1px solid #ccc'
                                    }
                                }
                            }
                        }
                    }}
                >
                    <div className="overflow-hidden text-ellipsis whitespace-nowrap max-w-full">
                        {params.value}
                    </div>
                </Tooltip>
            )
        },
        {
            field: 'remark',
            headerName: 'Açıklama',
            headerAlign: 'left',
            headerClassName: 'cell-header',
            cellClassName: 'cell-data',
            width: 300,
            renderCell: (params) => (
                <Tooltip
                    title={<div style={{ fontSize: '14px', padding: '8px' }}>{params.value || ''}</div>}
                    arrow
                    placement="top"
                    enterDelay={200}
                    componentsProps={{
                        tooltip: {
                            sx: {
                                maxWidth: '600px',
                                bgcolor: 'white',
                                color: 'black',
                                border: '1px solid #ccc',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                '& .MuiTooltip-arrow': {
                                    color: 'white',
                                    '&::before': {
                                        border: '1px solid #ccc'
                                    }
                                }
                            }
                        }
                    }}
                >
                    <div className="overflow-hidden text-ellipsis whitespace-nowrap max-w-full">
                        {params.value}
                    </div>
                </Tooltip>
            )
        },
        //{ field: 'odeme_yapilan_kart_bilgileri', headerName: 'Ödeme Yapılan Kart Bilgileri', headerAlign: 'center', headerClassName: 'cell-header', cellClassName: 'cell-data',width: 200 }

    ];

    const handleCloseDetailListDialogModal = () => {
        setOpenDetailListDialogModal(false);
    };


    const getTenantInfo = (discountCoupon) => {
        fetch(tenantInfoUrl,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'ApiAuthorization': 'Bearer '.concat(cookies.subscriptionToken)
                },
                body: JSON.stringify({discountCouponCodeDto : discountCoupon})
            })
            .then(res => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error(errorMessage);
                }
            })
            .then((data) => {
                if (!data) {
                    return;
                }
                let selectedSubscriptionFeatureTypeRequestDtoList = [];
                if (data.subscriptionFeatureTypeResponseDtoList) {
                    data.subscriptionFeatureTypeResponseDtoList.map(function (item) {
                        if (item.selected) {
                            selectedSubscriptionFeatureTypeRequestDtoList.push(item);
                        }
                        return item;
                    });
                }

                setRequestDto(
                    {
                        openUyapDosyaCount: data.openUyapDosyaCount,
                        tokenCount: data.tokenCount,
                        userCount: data.userCount,
                        ownerTenantId: data.ownerTenantId,
                        subscriptionFeatureTypeRequestDtoList: selectedSubscriptionFeatureTypeRequestDtoList,
                        activeDosyaCount: data.activeDosyaCount
                    }
                );

                setSelectedSubscriptionFeatureTypeDtoList(selectedSubscriptionFeatureTypeRequestDtoList);
                setPresaleMaxCount(data.presaleMaxFileCount);
                setTenantSubscriptionViewDto(data);

                let enableFixedDiscountCoupon = discountCoupon && discountCoupon.discountCouponDto.discountType === "FIXED";


                if((data.selectedSubscriptionBillingTypeEnumValue !== "PRESALE_DEMO" && data.validityStatusEnumValue !== "PASSIVE") || enableFixedDiscountCoupon){

                    setOldSubscriberUser(true);

                    setDefaultTenantProperties({
                        defaultUyapDosyaCount: data.openUyapDosyaCount,
                        defaultTokenCount: data.tokenCount,
                        defaultUserCount: data.userCount
                    });

                    setSelectedSubscriptionBillingTypeEnumValue(data.selectedSubscriptionBillingTypeEnumValue);
                    if (data.subscriptionFeatureTypeResponseDtoList && !discountCoupon) {
                        let ozellikList = data.subscriptionFeatureTypeResponseDtoList.map(obj => ({
                            ...obj,
                            disabled: obj.selected
                        }))
                        setSubscriptionFeatureTypeDtoList(ozellikList);
                    } else if (data.subscriptionFeatureTypeResponseDtoList && enableFixedDiscountCoupon) {
                        let ozellikList = data.subscriptionFeatureTypeResponseDtoList.map(obj => ({
                            ...obj,
                            disabled: obj.selected
                        }))
                        setSubscriptionFeatureTypeDtoList(ozellikList);
                    }

                } else {
                    if (data.subscriptionFeatureTypeResponseDtoList && !discountCoupon) {
                        setSubscriptionFeatureTypeDtoList(data.subscriptionFeatureTypeResponseDtoList);
                    }
                }

                setViewDto(data.subscriptionBillingCalculationResponseDto);
                setFeatureCount(data.selectedFeatureTypeCount);
                setReady(true);
                getHistoryData(data.ownerTenantId);
                if(discountCoupon){
                    onCompute(discountCoupon)
                }
            }, (error) => {
                debugLog(error);
                if (error) {
                    toast.error(error.message, {
                        position: toast.POSITION.TOP_CENTER
                    });
                    setLoginShow(true);

                }
            });
    }

    useEffect(() => {
        if (!cookies.subscriptionToken) {
            toast.error(connectionErrorMessage, {
                position: toast.POSITION.TOP_CENTER
            });
            return;
        }

        getTenantInfo();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cookies.subscriptionToken]);

    useEffect(() => {
        if (actionCount > 0) {
            const timer = setTimeout(() => {
                if (featureCount > 0) {
                    onCompute();
                } else {
                    setViewDto(defaultViewDto);
                    toast.error(minimumFeatureTypeSelectionMessage, {
                        position: toast.POSITION.TOP_CENTER
                    });
                    return;
                }
            }, 500);

            return () => clearTimeout(timer);
        }// eslint-disable-next-line react-hooks/exhaustive-deps
    }, [actionCount]);

    const onChangeOpenUyapDosyaCount = (item) => {
        if (item.target.value >= 0 && item.target.value < maxCount) {
            let uyapDosyaCount = item.target.value;
            if (defaultTenantProperties && defaultTenantProperties.defaultUyapDosyaCount > uyapDosyaCount &&
                !item.nativeEvent.inputType && item.nativeEvent.inputType !== "insertText") {
                uyapDosyaCount = defaultTenantProperties.defaultUyapDosyaCount;
            }
            setRequestDto({
                ...requestDto,
                openUyapDosyaCount: uyapDosyaCount
            });
            setActionCount(actionCount + 1);
        }
    };
    const onChangeTokenCount = (item) => {
        if (item.target.value >= 0 && item.target.value < maxCount) {
            let tokenCount = item.target.value;
            if (defaultTenantProperties && defaultTenantProperties.defaultTokenCount > tokenCount &&
                !item.nativeEvent.inputType && item.nativeEvent.inputType !== "insertText") {
                tokenCount = defaultTenantProperties.defaultTokenCount;
            }
            setRequestDto({
                ...requestDto,
                tokenCount: tokenCount
            });
            setActionCount(actionCount + 1);
        }
    };
    const onChangeUserCount = (item) => {
        if (item.target.value >= 0 && item.target.value < maxCount) {
            let userCount = item.target.value;
            if (defaultTenantProperties && defaultTenantProperties.defaultUserCount > userCount &&
                !item.nativeEvent.inputType && item.nativeEvent.inputType !== "insertText") {
                userCount = defaultTenantProperties.defaultUserCount;
            }
            setRequestDto({
                ...requestDto,
                userCount: userCount
            });
            setActionCount(actionCount + 1);
        }
    };

    const handleCardNumberChange = (e) => {
        const {value} = e.target;

        if (value) {
            let formattedValue = formatCardNumber(value);
            if (value.length <= 19) {
                setCardState({...cardState, focus: 'number', 'number': formattedValue});
            }
            if (formattedValue.length >= 19) {
                setValidState({...validState, number: true});
            } else {
                setValidState({...validState, number: false});
            }
        } else {
            setCardState({...cardState, focus: 'number', 'number': value});
            setValidState({...validState, number: false});
        }

    }

    const handleCardCVCChange = (e) => {
        const {value} = e.target;
        if (value) {
            if (value.length < 4) {
                setCardState({...cardState, focus: 'cvc', 'cvc': formatCvc(value)});
            }
        } else {
            setCardState({...cardState, focus: 'cvc', 'cvc': ''});
        }

        if (e.target.value && e.target.value.length >= 3) {
            setValidState({...validState, cvc: true});
        } else {
            setValidState({...validState, cvc: false});
        }
    }

    const handleCardExpiryChange = (e) => {
        if (e.target.value) {
            setCardState({...cardState, focus: 'expiry', expiry: formatExpiry(e)});
        } else {
            setCardState({...cardState, focus: 'expiry', expiry: ''});
        }

        if (e.target.value && e.target.value.length >= 7) {
            setValidState({...validState, expiry: true});
        } else {
            setValidState({...validState, expiry: false});
        }
    }

    const handleEmailChange = (e) => {
        if (e.target.value) {
            setCardState({...cardState, email: e.target.value});
        } else {
            setCardState({...cardState, email: ''});
        }

        if (e.target.value && EMAIL_VALIDATE.test(e.target.value)) {
            setValidState({...validState, email: true});
        } else {
            setValidState({...validState, email: false});
        }
    }

    const handleGsmChange = (e) => {
        if (e.target.value) {
            if (e.target.value.length < 12 && ONLY_NUMBER_REGEX.test(e.target.value)) {
                setCardState({...cardState, gsm: e.target.value});
            }
        } else {
            setCardState({...cardState, gsm: ''});
        }

        if (e.target.value && e.target.value.length >= 11 && ONLY_NUMBER_REGEX.test(e.target.value)) {
            setValidState({...validState, gsm: true});
        } else {
            setValidState({...validState, gsm: false});
        }
    }

    const handleCardNameChange = (e) => {
        const {value} = e.target;
        setCardState({...cardState, focus: 'name', name: value});
        if (value && value.length > 0) {
            setValidState({...validState, name: true});
        } else {
            setValidState({...validState, name: false});
        }
    }

    const onChangeFeatureAll = (itemChanged) => {
        if (itemChanged.target.checked) {
            let selectedDtoList = [];
            subscriptionFeatureTypeDtoList.map(function (item) {
                if (item.active) {
                    if (item.disabled !== true) {
                        item.selected = true;
                    }
                    selectedDtoList.push(item);
                }
                return item;
            });
            setSubscriptionFeatureTypeDtoList(subscriptionFeatureTypeDtoList);
            setSelectedSubscriptionFeatureTypeDtoList(selectedDtoList);
            setSelectAllFeatures(true);
            setFeatureCount(selectedDtoList.length);
            setActionCount(actionCount + 1);
        } else {
            subscriptionFeatureTypeDtoList.map((item) => {
                if (item.disabled !== true) {
                    item.selected = false;
                }
                return item;
            });
            setSubscriptionFeatureTypeDtoList(subscriptionFeatureTypeDtoList);
            setSelectedSubscriptionFeatureTypeDtoList([]);
            setSelectAllFeatures(false);
            setViewDto(defaultViewDto);
            setFeatureCount(0);
            setActionCount(0);
        }
    }

    const onChangeFeature = (itemChanged) => {
        let selectedSubscriptionFeatureTypeList = [];
        subscriptionFeatureTypeDtoList.map(function (item) {
            if (itemChanged.target.id.toString() === item.id.toString()) {
                item.selected = itemChanged.target.checked;
            }
            if (item.selected) {
                selectedSubscriptionFeatureTypeList.push(item);
            }
            return item;
        });
        setSubscriptionFeatureTypeDtoList(subscriptionFeatureTypeDtoList);
        setSelectedSubscriptionFeatureTypeDtoList(selectedSubscriptionFeatureTypeList);
        let newFeatureCount;
        if (itemChanged.target.checked) {
            newFeatureCount = featureCount + 1;
            setFeatureCount(newFeatureCount);
        } else {
            newFeatureCount = featureCount - 1;
            setFeatureCount(newFeatureCount);
        }

        if (newFeatureCount === 0) {
            setSelectAllFeatures(false);
        }
        setActionCount(actionCount + 1);
    };

    const getSelectedBill = (showDiscountCoupon = false) => {
        if (viewDto.selectedBillingDto) {
            return showDiscountCoupon ? viewDto.selectedBillingDto?.discountCouponToTotalBillWithKDV?.toFixed(2) : viewDto.selectedBillingDto?.discountedTotalBillWithKDV?.toFixed(2);
        } else if (selectedSubscriptionBillingTypeEnumValue === 'PRESALE_MONTH') {
            return showDiscountCoupon ? viewDto.oneMonthDto?.discountCouponToTotalBillWithKDV?.toFixed(2) : viewDto.oneMonthDto?.discountedTotalBillWithKDV?.toFixed(2);
        } else if (selectedSubscriptionBillingTypeEnumValue === 'PRESALE_QUARTER') {
            return showDiscountCoupon ? viewDto.threeMonthDto?.discountCouponToTotalBillWithKDV?.toFixed(2) : viewDto.threeMonthDto?.discountedTotalBillWithKDV?.toFixed(2);
        } else if (selectedSubscriptionBillingTypeEnumValue === 'PRESALE_HALF') {
            return showDiscountCoupon ? viewDto.sixMonthDto?.discountCouponToTotalBillWithKDV?.toFixed(2) : viewDto.sixMonthDto?.discountedTotalBillWithKDV?.toFixed(2);
        } else if (selectedSubscriptionBillingTypeEnumValue === 'PRESALE_YEAR') {
            return showDiscountCoupon ? viewDto.oneYearDto?.discountCouponToTotalBillWithKDV?.toFixed(2) : viewDto.oneYearDto?.discountedTotalBillWithKDV?.toFixed(2);
        }
    }
    const getSelectedBillForKDVAmount = (showDiscountCoupon = false) => {
        if (viewDto.selectedBillingDto) {
            return showDiscountCoupon ? viewDto.selectedBillingDto?.kdvCouponAmount?.toFixed(2) : viewDto.selectedBillingDto?.kdvAmount?.toFixed(2);
        } else if (selectedSubscriptionBillingTypeEnumValue === 'PRESALE_MONTH') {
            return showDiscountCoupon ? viewDto.oneMonthDto?.kdvCouponAmount?.toFixed(2) : viewDto.oneMonthDto?.kdvAmount?.toFixed(2);
        } else if (selectedSubscriptionBillingTypeEnumValue === 'PRESALE_QUARTER') {
            return showDiscountCoupon ? viewDto.threeMonthDto?.kdvCouponAmount?.toFixed(2) : viewDto.threeMonthDto?.kdvAmount?.toFixed(2);
        } else if (selectedSubscriptionBillingTypeEnumValue === 'PRESALE_HALF') {
            return showDiscountCoupon ? viewDto.sixMonthDto?.kdvCouponAmount?.toFixed(2) : viewDto.sixMonthDto?.kdvAmount?.toFixed(2);
        } else if (selectedSubscriptionBillingTypeEnumValue === 'PRESALE_YEAR') {
            return showDiscountCoupon ? viewDto.oneYearDto?.kdvCouponAmount?.toFixed(2) : viewDto.oneYearDto?.kdvAmount?.toFixed(2);
        }
    }

    const getSelectedDiscountCouponToBill = () => {
        if (viewDto.selectedBillingDto) {
            return viewDto.selectedBillingDto.discountCouponToTotalBillWithKDV?.toFixed(2);
        } else if (selectedSubscriptionBillingTypeEnumValue === 'PRESALE_MONTH') {
            return viewDto.oneMonthDto?.discountCouponToTotalBillWithKDV?.toFixed(2);
        } else if (selectedSubscriptionBillingTypeEnumValue === 'PRESALE_QUARTER') {
            return viewDto.threeMonthDto?.discountCouponToTotalBillWithKDV?.toFixed(2);
        } else if (selectedSubscriptionBillingTypeEnumValue === 'PRESALE_HALF') {
            return viewDto.sixMonthDto?.discountCouponToTotalBillWithKDV?.toFixed(2);
        } else if (selectedSubscriptionBillingTypeEnumValue === 'PRESALE_YEAR') {
            return viewDto.oneYearDto?.discountCouponToTotalBillWithKDV?.toFixed(2);
        }
    }


    const getSelectedDiscountCouponToBillForKDVAmount = (showDiscountCoupon = false) => {

        if (viewDto.selectedBillingDto) {
            return viewDto.selectedBillingDto.kdvCouponAmount?.toFixed(2);
        } else if (selectedSubscriptionBillingTypeEnumValue === 'PRESALE_MONTH') {
            return viewDto.oneMonthDto?.kdvCouponAmount?.toFixed(2);
        } else if (selectedSubscriptionBillingTypeEnumValue === 'PRESALE_QUARTER') {
            return viewDto.threeMonthDto?.kdvCouponAmount?.toFixed(2);
        } else if (selectedSubscriptionBillingTypeEnumValue === 'PRESALE_HALF') {
            return viewDto.sixMonthDto?.kdvCouponAmount?.toFixed(2);
        } else if (selectedSubscriptionBillingTypeEnumValue === 'PRESALE_YEAR') {
            return viewDto.oneYearDto?.kdvCouponAmount?.toFixed(2);
        }
    }

    const getSelectedAccountOption = () => {

        if (selectedSubscriptionBillingTypeEnumValue === 'PRESALE_MONTH') {
            return '1 Aylık Üyelik';
        } else if (selectedSubscriptionBillingTypeEnumValue === 'PRESALE_QUARTER') {
            return '3 Aylık Üyelik';
        } else if (selectedSubscriptionBillingTypeEnumValue === 'PRESALE_HALF') {
            return '6 Aylık Üyelik';
        } else if (selectedSubscriptionBillingTypeEnumValue === 'PRESALE_YEAR') {
            return '1 Yıllık Üyelik';
        }
    }


    const modalHandleClose = () => {
        setCardState({
            cvc: '',
            expiry: '',
            focus: '',
            name: '',
            number: '',
        });
        setValidState({
            cvc: false,
            expiry: false,
            name: false,
            number: false,
            email: false,
            gsm: false
        });
        setCreditCardValidated(false);
        setModalShow(false);
        //window.location.reload();
    }

    const secureScreenClose = () => {
        setSecureUrl('');
        setSecureScreenShow(false);
    }

    const validateCard = () => {
        if (!(validState.cvc && validState.expiry && validState.name && validState.number && validState.gsm && validState.email)) {
            setCreditCardValidated(true);
            return false;
        }
        return true;
    }

    const pay = () => {
        const [head, ...tail] = cardState.expiry.split(' / ');
        let subscriptionFeatureTypeRequestDtoList = [];
        subscriptionFeatureTypeDtoList.map(function (item) {
            subscriptionFeatureTypeRequestDtoList.push({
                enumValue: item.enumValue,
                selected: item.selected
            });
            return item;
        });

        if (!validateCard()) {
            return;
        }



        let paymentRequestDto = {
            subscriptionBillingTypeEnumValue: selectedSubscriptionBillingTypeEnumValue,
            subscriptionPaymentMethodEnumValue: 'CREDIT_CARD',
            paymentSystemReferenceValue: 'UYAP',
            creditCardOwner: cardState.name,
            creditCardNo: cardState.number,
            creditCardLastUsageMonth: head,
            creditCardLastUsageYear: '20'.concat(tail),
            creditCardCvc: cardState.cvc,
            creditCardOwnerGsm: cardState.gsm,
            billingEmail: cardState.email,
            remark: selectedSubscriptionBillingTypeEnumValue.concat(getSelectedBill()),
            subscriptionBillingCalculationRequestDto: {...requestDto, subscriptionFeatureTypeRequestDtoList}
        }
        if(enableDiscountCodeSuccess && discountCouponCodeDto) {
            paymentRequestDto.subscriptionBillingCalculationRequestDto = {...paymentRequestDto.subscriptionBillingCalculationRequestDto,discountCouponCodeDto};
        }
        setPaymentProcessing(true);
        try {
            fetch(payUrl, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'ApiAuthorization': 'Bearer '.concat(cookies.subscriptionToken)
                },
                body: JSON.stringify(paymentRequestDto)
            }).then(res => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error(connectionErrorMessage);
                }
            })
                .then((data) => {
                    if (data.sonuc > 0) {
                        setCardState({
                            cvc: '',
                            expiry: '',
                            focus: '',
                            name: '',
                            number: ''
                        });
                        setSecureUrl(data.ucdurl);
                        setModalShow(false);
                        setSecureScreenShow(true);
                        setPaymentProcessing(false);
                    } else {
                        toast.error(data.sonucStr, {
                            position: toast.POSITION.TOP_CENTER
                        });
                        setPaymentProcessing(false);
                    }
                }, (error) => {
                    if (error) {
                        toast.error(error.message, {
                            position: toast.POSITION.TOP_CENTER
                        });
                    }
                    setPaymentProcessing(false);
                });

            window.scrollTo(0, 0);
        } catch (e) {
            toast.error(errorMessage);
        }
    }

    const openPaymentModal = () => {

        if (selectedSubscriptionBillingTypeEnumValue) {
            setModalShow(true);
            setCreditCardValidated(false);
            setCardState({
                cvc: '',
                expiry: '',
                focus: '',
                name: '',
                number: ''
            })
        } else {
            toast.error(selectSubscriptionBillingTypeMessage, {
                position: toast.POSITION.TOP_CENTER
            });
        }
    }


    const modalHandleOpen = () => {
        checkAdminManagement();
        if (selectedSubscriptionBillingTypeEnumValue) {
            if (getSelectedBill(enableDiscountCodeSuccess) > 0) {
                if (!hasSourceSystemEntegration(selectedSubscriptionFeatureTypeDtoList)) {
                    handleValidSourceSystemEntegrationOpenDialog();
                } else {
                    if (selectedSubscriptionFeatureTypeDtoList &&
                        selectedSubscriptionFeatureTypeDtoList.filter((item) => {
                            return (!item.disabled && item.enumValue.startsWith('SOURCE_SYSTEM_ENTEGRATION_'))
                        }).length > 0) {
                        handleInfoSourceSystemEntegrationOpenDialog();
                        return;
                    } else {
                        openPaymentModal();
                        return;
                    }
                }
            }
        } else {
            toast.error(selectSubscriptionBillingTypeMessage, {
                position: toast.POSITION.TOP_CENTER
            });
        }
    }

    const hasSourceSystemEntegration = (selectedSubscriptionFeatureTypeDtoList) => {
        if (selectedSubscriptionFeatureTypeDtoList != null && selectedSubscriptionFeatureTypeDtoList.length > 0) {
            if (selectedSubscriptionFeatureTypeDtoList.filter(item => item.subscriptionServiceFeatureCategoryTypeEnumValue === "CORPORATION_ENTEGRATION").length > 0) {
                return true;
            }
        }

        return false;
    }

    const calculate = (newRequestDto) => {
        fetch(calculateUrl, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(newRequestDto)
        }).then(res => {
            if (res.ok) {
                return res.json();
            } else if (res.text) {
                return res.text().then(text => { throw new Error(text) })
            } else {
                throw new Error(connectionErrorMessage);
            }
        })
            .then((data) => {
                setViewDto(data)
            }, (error) => {
                if (error) {
                    toast.error(error.message, {
                        position: toast.POSITION.TOP_CENTER
                    });
                    setLoginShow(true);
                }
            });
    }

    const onCompute = (discountCoupon) => {
        let isAnySelectedFeatureType = false;
        let subscriptionFeatureTypeRequestDtoList = [];
        subscriptionFeatureTypeDtoList.map(function (item) {
            subscriptionFeatureTypeRequestDtoList.push({
                enumValue: item.enumValue,
                selected: item.selected
            });

            if (item.selected) {
                isAnySelectedFeatureType = true;
            }
            return item;
        });

        if (defaultTenantProperties && oldSubscriberUser) {
            if ((requestDto.openUyapDosyaCount < defaultTenantProperties.defaultUyapDosyaCount) ||
                (requestDto.tokenCount < defaultTenantProperties.defaultTokenCount) ||
                (requestDto.userCount < defaultTenantProperties.defaultUserCount)) {

                if (!toast.isActive(warningTenantPropertiesCountId)) {
                    toast.error(warningTenantPropertiesCountMessage, {
                        position: toast.POSITION.TOP_CENTER,
                        toastId: warningTenantPropertiesCountId
                    });

                }
                return;
            }
        }

        if (requestDto.openUyapDosyaCount > presaleMaxCount) {
            if (!toast.isActive(overFlowDosyaCountMessageId)) {
                toast.info(overFlowDosyaCountMessage, {
                    position: toast.POSITION.TOP_CENTER,
                    toastId: overFlowDosyaCountMessageId
                });

            }
            return;
        }

        if (!isAnySelectedFeatureType) {
            if (!toast.isActive(minimumFeatureTypeSelectionMessageId)) {
                toast.error(minimumFeatureTypeSelectionMessage, {
                    position: toast.POSITION.TOP_CENTER,
                    toastId: minimumFeatureTypeSelectionMessageId
                });
            }
            return;
        }

        if (!requestDto.openUyapDosyaCount || (parseInt(requestDto.openUyapDosyaCount) === 0)) {
            if (!toast.isActive(minimumDosyaCountId)) {
                toast.error(minimumDosyaCount, {
                    position: toast.POSITION.TOP_CENTER,
                    toastId: minimumDosyaCountId
                });
            }
            return;
        }

        if (!requestDto.tokenCount || (parseInt(requestDto.tokenCount) === 0)) {
            if (!toast.isActive(minimumTokenCountId)) {
                toast.error(minimumTokenCount, {
                    position: toast.POSITION.TOP_CENTER,
                    toastId: minimumTokenCountId
                });
            }
            return;
        }

        if (!requestDto.userCount || (parseInt(requestDto.userCount) === 0)) {
            if (!toast.isActive(minimumUserCountId)) {
                toast.error(minimumUserCount, {
                    position: toast.POSITION.TOP_CENTER,
                    toastId: minimumUserCountId
                });
            }
            return;
        }

        try {
            let newRequestDto = {...requestDto, subscriptionFeatureTypeRequestDtoList};
            if(enableDiscountCodeSuccess && discountCouponCodeDto) {
                newRequestDto = {...newRequestDto, discountCouponCodeDto};
            } else if (discountCoupon){
                //firstTime
                newRequestDto = {...newRequestDto, discountCouponCodeDto : discountCoupon}
                if(discountCoupon?.discountCouponDto?.subscriptionServiceFeatureTypeSet && discountCoupon?.discountCouponDto?.subscriptionServiceFeatureTypeSet?.length > 0){
                    let subscriptionServiceFeatureTypeSet = discountCoupon.discountCouponDto.subscriptionServiceFeatureTypeSet ;
                    subscriptionServiceFeatureTypeSet.map(function(i) {
                        i.selected = true;
                        return i
                    });
                    setFeatureCount(subscriptionServiceFeatureTypeSet.length);
                    if(discountCoupon?.discountCouponDto?.declaredUserCount){
                        newRequestDto.userCount = discountCoupon.discountCouponDto.declaredUserCount;
                    }
                    if(discountCoupon?.discountCouponDto?.declaredFileCount){
                        newRequestDto.openUyapDosyaCount = discountCoupon.discountCouponDto.declaredFileCount;
                    }
                    if(discountCoupon?.discountCouponDto?.declaredTokenCount){
                        newRequestDto.tokenCount = discountCoupon.discountCouponDto.declaredTokenCount;
                    }

                    setDefaultTenantProperties({
                        defaultUyapDosyaCount: newRequestDto.openUyapDosyaCount,
                        defaultTokenCount: newRequestDto.tokenCount,
                        defaultUserCount: newRequestDto.userCount
                    });

                    newRequestDto = {...newRequestDto,subscriptionFeatureTypeRequestDtoList:subscriptionServiceFeatureTypeSet};
                    setRequestDto(newRequestDto);
                }
            }
            calculate(newRequestDto);
            window.scrollTo(0, 0);
        } catch (e) {
            toast.error(errorMessage);
        }
    }



    const handlePaymentTestResponse = (res, isSuccess) => {
        if (res.type === 'opaqueredirect' || res.status === 0 || res.ok) {
            if (isSuccess) {
                toast.success("Test ödemesi BAŞARILI olarak işaretlendi. (Ödeme ID: " + payPaymentId + ")", {
                    position: toast.POSITION.TOP_CENTER
                });
            } else {
                toast.info("Test ödemesi BAŞARISIZ olarak işaretlendi. (Ödeme ID: " + payPaymentId + ")", {
                    position: toast.POSITION.TOP_CENTER
                });
            }
            secureScreenClose();
        } else {
            toast.error("İşlem gerçekleştirilemedi (HTTP " + res.status + "). Lütfen Ödeme ID'sini kontrol edin.", {
                position: toast.POSITION.TOP_CENTER
            });
            setTestProcessing(false);
        }
    };

    const successPayTest = () => {
        if (!payPaymentId) {
            toast.error("Lütfen Ödeme ID giriniz!", {
                position: toast.POSITION.TOP_CENTER
            });
            return;
        }
        if (testProcessing) {
            return;
        }
        setTestProcessing(true);

        fetch(testSuccessPaymentUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({
                "TURKPOS_RETVAL_Sonuc": 1,
                "TURKPOS_RETVAL_Sonuc_Str": "1 - Başarılı",
                "TURKPOS_RETVAL_GUID": "123e4567-e89b-12d3-a456-426655440000",
                "TURKPOS_RETVAL_Islem_Tarih": new Date(),
                "TURKPOS_RETVAL_Dekont_ID": payPaymentId,
                "TURKPOS_RETVAL_Tahsilat_Tutari": 0,
                "TURKPOS_RETVAL_Odeme_Tutari": 0,
                "TURKPOS_RETVAL_Siparis_ID": payPaymentId,
                "TURKPOS_RETVAL_Islem_ID": payPaymentId,
                "TURKPOS_RETVAL_Ext_Data": {"EkBilgi": "Veri 1","EkBilgi2": "Veri 2"},
                "TURKPOS_RETVAL_Banka_Sonuc_Kod": "00"
            }),
            redirect: 'manual'
        }).then((res) => handlePaymentTestResponse(res, true))
            .catch((error) => {
                debugLog(error);
                toast.error("Bağlantı hatası: işlem gerçekleştirilemedi.", {
                    position: toast.POSITION.TOP_CENTER
                });
                setTestProcessing(false);
            });
    }

    const checkAdminManagement = () => {
        fetch(adminManagementCheckUrl, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'ApiAuthorization': 'Bearer '.concat(cookies.subscriptionToken)
            },
        }).then(res => {
            if (res.ok) {
                setHasAdminManagement(true)
            } else {
                setHasAdminManagement(false)
            }
        })
    }


    const onChangePayPaymentId = (item) => {
        if (item.target.value >= 0) {
            setPayPaymentId(item.target.value);
        }
    };

    const errorPayTest = () => {
        if (!payPaymentId) {
            toast.error("Lütfen Ödeme ID giriniz!", {
                position: toast.POSITION.TOP_CENTER
            });
            return;
        }
        if (testProcessing) {
            return;
        }
        setTestProcessing(true);

        fetch(testErrorPaymentUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({
                "TURKPOS_RETVAL_Sonuc": 0,
                "TURKPOS_RETVAL_Sonuc_Str": "0 - Başarısız",
                "TURKPOS_RETVAL_GUID": "123e4567-e89b-12d3-a456-426655440000",
                "TURKPOS_RETVAL_Islem_Tarih": new Date(),
                "TURKPOS_RETVAL_Dekont_ID": "123456789",
                "TURKPOS_RETVAL_Tahsilat_Tutari": 0,
                "TURKPOS_RETVAL_Odeme_Tutari": 0,
                "TURKPOS_RETVAL_Siparis_ID": payPaymentId,
                "TURKPOS_RETVAL_Islem_ID": payPaymentId,
                "TURKPOS_RETVAL_Ext_Data": {"EkBilgi": "Veri 1","EkBilgi2": "Veri 2"},
                "TURKPOS_RETVAL_Banka_Sonuc_Kod": "00"
            }),
            redirect: 'manual'
        }).then((res) => handlePaymentTestResponse(res, false))
            .catch((error) => {
                debugLog(error);
                toast.error("Bağlantı hatası: işlem gerçekleştirilemedi.", {
                    position: toast.POSITION.TOP_CENTER
                });
                setTestProcessing(false);
            });
    }

    const getHistoryData = (selectionModel) => {
        if (selectionModel) {
            fetch(getPaymentHistoryUrl + "/" + selectionModel, {
                method: 'GET',
                headers: {
                    'ApiAuthorization': 'Bearer '.concat(cookies.subscriptionToken),
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
            }).then(res => {
                if (res.ok) {
                    return res.json();
                }
            }).then((data) => {
                if (!data) {
                    return;
                }

                moment.locale('tr')

                for (var i = 0; i < data.length; i++) {
                    data[i].id = i + '' + data[i].id;
                    data[i].validIntervalEndDateTime = moment(data[i].validIntervalEndDateTime).format("LL");
                    data[i].validIntervalBeginDateTime = moment(data[i].validIntervalBeginDateTime).format("LLL");
                    data[i].paymentDatepaymentDate = moment(data[i].paymentDatepaymentDate).format("LLL");
                    data[i].lastModifiedDateTime = moment(data[i].lastModifiedDateTime).format("LLL");
                    data[i].featureCount = data[i].featureCount > 0 ? data[i].featureCount : "";
                }

                setPaymentHistoryData(data)
            })
        }
    }

    const GenereateFeature = () => {
        return (
            <React.Fragment>{
                subscriptionFeatureTypeDtoList.map(function (ozellikler) {
                    return (
                        <tr key={ozellikler.id || 'TR'}
                            style={{lineHeight: 1.5, height: "10px", fontSize: 12, verticalAlign: "middle"}}>
                            <td>
                                <Form.Check
                                    type='checkbox'
                                    custom
                                    style={{"textAlign": "right", "verticalAlign": "right"}}
                                    id={ozellikler.id}
                                    checked={ozellikler.selected}
                                    disabled={!ozellikler.active || ozellikler.disabled}
                                    onChange={onChangeFeature}
                                />
                            </td>
                            <td style={ozellikler.active ? {verticalAlign: "middle", "whiteSpace": "nowrap"} : {
                                verticalAlign: "middle",
                                color: "lightgrey",
                                "whiteSpace": "nowrap"
                            }}>
                                {ozellikler.subscriptionServiceFeatureCategoryTypeName}
                            </td>
                            <td style={ozellikler.active ? {verticalAlign: "middle", "whiteSpace": "nowrap"} : {
                                verticalAlign: "middle",
                                color: "lightgrey",
                                "whiteSpace": "nowrap"
                            }}>
                                <div>{ozellikler.name}
                                    <Tooltip title={ozellikler.tooltip ? "" : "Bilgi Yok"} aria-label="add">
                                        <InfoTwoTone style={{color: "rgb(0, 0, 139)", float: "right"}}
                                                     onClick={() => handleOpenTooltipModal(ozellikler)}/>
                                    </Tooltip>
                                </div>
                            </td>
                        </tr>
                    )
                })
            }
            </React.Fragment>);
    };

    const GenereateSelectedFeature = () => {
        return (
            <React.Fragment>{
                selectedSubscriptionFeatureTypeDtoList.sort(function (a, b) {
                    return a.disabled - b.disabled
                }).map(function (ozellikler) {
                    return (
                        <tr key={ozellikler.id || 'TR'}
                            style={{
                                lineHeight: 2, height: "10px", fontSize: 12, verticalAlign: "middle"
                                , color: (ozellikler.disabled === false) ? "red" : "black"
                            }}>
                            <td style={{verticalAlign: "middle"}}>
                                {ozellikler.subscriptionServiceFeatureCategoryTypeName}
                            </td>
                            <td style={{verticalAlign: "middle"}} title={ozellikler.tooltip}>
                                {ozellikler.name}
                            </td>
                        </tr>
                    )
                })
            }
            </React.Fragment>);
    };

    const CalculationResultPart = () => {
        return (<UgyPlansYearly ugyDto={viewDto}
                                enableCheckBoxIcon={true}
                                selectedEnumValue={selectedSubscriptionBillingTypeEnumValue}
                                setSelectedEnumValue={setSelectedSubscriptionBillingTypeEnumValue}
                                selectedBillingDto={viewDto.selectedBillingDto || (enableDiscountCodeSuccess &&  discountCouponCodeDto?.discountCouponDto?.discountType === "FIXED")}/>);
    };

    const CalculationButtonsPart = () => {
        return (
            <Row className="pt-2" style={{ width: "100%" }}>
                <Col className="pt-2">
                    <Row className="justify-content-end" style={{display: "block"}}>
                        <Row className="justify-content-end">
                            <div style={{alignItems: 'center', display: 'flex',
                                textAlign: 'start'}}>
                                <CardGiftcardIcon
                                    fontSize='large'
                                    color={enableDiscountCodeSuccess ? "success" : "warning"}
                                />
                                {(!enableDiscountCodeSuccess) && (
                                    <>
                                        <FormControl
                                            onChange={onChangeDiscountCouponCodeInput}
                                            value={discountCouponCodeValue}
                                            placeholder="Kampanya Kodu"
                                            style={{ width: '160px' }}
                                            type='text'
                                        />
                                        <SendIcon fontSize='large' onClick={() => sendDiscountCouponCode()}
                                                  color={"success"}/>
                                    </>
                                )}
                                {enableDiscountCodeSuccess && (
                                    <button style={{
                                        backgroundColor: '#04AA6D',
                                        border: 'none',
                                        color: 'white',
                                        textAlign: 'center',
                                        textDecoration: 'none',
                                        display: ' inline-block',
                                        borderRadius: '50%'
                                    }}>
                                        {discountCouponCodeDto &&
                                            discountCouponCodeDto.discountCouponDto &&
                                            (discountCouponCodeDto.discountCouponDto.discountRate ? ("%" + discountCouponCodeDto.discountCouponDto.discountRate) :
                                                discountCouponCodeDto.discountCouponDto.discountAmount ? ("-" + discountCouponCodeDto.discountCouponDto.discountAmount + " TL") : "")
                                        }
                                    </button>
                                )}
                            </div>
                            <div style={{display: 'flex', flexDirection: 'column'}}>
                                <div
                                    style={{display: 'flex', alignItems: 'center', marginBottom: 0, paddingRight: 110}}>
                                    <InputGroup>
                                        {getSelectedAccountOption() && <InputGroup.Text  style={{minWidth:161, alignItems:"center",
                                            justifyContent: "center", marginRight:"35px"}}>{getSelectedAccountOption()}</InputGroup.Text>}
                                        {enableDiscountCodeSuccess && discountCouponCodeDto?.discountCouponDto?.discountType === "FIXED" && <>
                                            <NumberFormat
                                                value={discountCouponCodeDto?.discountCouponDto?.fixedAmount}
                                                displayType={'text'}
                                                thousandSeparator={true}
                                                renderText={value =>
                                                    <Form.Control
                                                        type='text'
                                                        style={{
                                                            "textAlign": "end",
                                                            "verticalAlign": "middle",
                                                            "color": 'white', "backgroundColor": "#04AA6D",
                                                            "maxWidth": 120
                                                        }}
                                                        value={value}
                                                        disabled={true}
                                                    />
                                                }
                                            />
                                            <InputGroup.Append>
                                                <InputGroup.Text style={{
                                                    "color": 'white', "backgroundColor": "#04AA6D"
                                                }}>TL</InputGroup.Text>
                                            </InputGroup.Append>
                                        </>}
                                    </InputGroup>
                                </div>
                            </div>
                        </Row>
                        <Row className="justify-content-end">
                            <div style={{display: 'flex', flexDirection: 'column'}}>
                                <div
                                    style={{display: 'flex', alignItems: 'center', marginBottom: 0, paddingRight: 145}}>
                                    <Form.Label style={{
                                        minWidth: '150px',
                                        textAlign: 'end',
                                        marginRight: '10px',
                                        fontWeight: '600'
                                    }}>KDV Tutarı:</Form.Label>
                                    <InputGroup>
                                        <NumberFormat
                                            value={getSelectedBillForKDVAmount(false)}
                                            displayType={'text'}
                                            thousandSeparator={true}
                                            renderText={value =>
                                                <Form.Control
                                                    type='text'
                                                    style={{
                                                        "textDecoration": enableDiscountCodeSuccess ? "line-through" : "",
                                                        "textAlign": "end",
                                                        "verticalAlign": "middle",
                                                        "maxWidth": 120
                                                    }}
                                                    value={value}
                                                    disabled={true}
                                                />
                                            }
                                        />
                                        <InputGroup.Append>
                                            <InputGroup.Text
                                                style={{"textDecoration": enableDiscountCodeSuccess ? "line-through" : ""}}>TL</InputGroup.Text>
                                        </InputGroup.Append>
                                    </InputGroup>
                                    {enableDiscountCodeSuccess && (
                                        <InputGroup>
                                            <NumberFormat
                                                value={getSelectedDiscountCouponToBillForKDVAmount()}
                                                displayType={'text'}
                                                thousandSeparator={true}
                                                renderText={value =>
                                                    <Form.Control
                                                        type='text'
                                                        style={{
                                                            "textAlign": "end",
                                                            "verticalAlign": "middle",
                                                            "color": 'white', "backgroundColor": "#04AA6D",
                                                            "maxWidth": 120
                                                        }}
                                                        value={value}
                                                        disabled={true}
                                                    />
                                                }
                                            />
                                            <InputGroup.Append>
                                                <InputGroup.Text style={{
                                                    "color": 'white', "backgroundColor": "#04AA6D"
                                                }}>TL</InputGroup.Text>
                                            </InputGroup.Append>
                                        </InputGroup>
                                    )}
                                </div>
                            </div>
                        </Row>
                        <Row className="justify-content-end">
                            <div style={{display: 'flex', flexDirection: 'column'}}>
                                <div style={{display: 'flex', alignItems: 'center', marginBottom: 10}}>
                                    <Form.Label style={{
                                        minWidth: '300px',
                                        marginRight: '10px',
                                        textAlign: 'end',
                                        fontWeight: '600'
                                    }}>KDV Dahil Toplam
                                        Tutar:</Form.Label>
                                    <InputGroup>
                                        <NumberFormat
                                            value={getSelectedBill(false)}
                                            displayType={'text'}
                                            thousandSeparator={true}
                                            renderText={value =>
                                                <Form.Control
                                                    type='text'
                                                    style={{
                                                        "textDecoration": enableDiscountCodeSuccess ? "line-through" : "",
                                                        "textAlign": "end",
                                                        "verticalAlign": "middle",
                                                        "maxWidth": 120
                                                    }}
                                                    value={value}
                                                    disabled={true}
                                                />
                                            }
                                        />
                                        <InputGroup.Append>
                                            <InputGroup.Text
                                                style={{"textDecoration": enableDiscountCodeSuccess ? "line-through" : ""}}>TL</InputGroup.Text>
                                        </InputGroup.Append>
                                    </InputGroup>
                                    {enableDiscountCodeSuccess && (
                                        <InputGroup>
                                            <NumberFormat
                                                value={getSelectedDiscountCouponToBill()}
                                                displayType={'text'}
                                                thousandSeparator={true}
                                                renderText={value =>
                                                    <Form.Control
                                                        type='text'
                                                        style={{
                                                            "textAlign": "end",
                                                            "verticalAlign": "middle",
                                                            "color": 'white', "backgroundColor": "#04AA6D",
                                                            "maxWidth": 120
                                                        }}
                                                        value={value}
                                                        disabled={true}
                                                    />
                                                }
                                            />
                                            <InputGroup.Append>
                                                <InputGroup.Text style={{
                                                    "color": 'white', "backgroundColor": "#04AA6D"
                                                }}>TL</InputGroup.Text>
                                            </InputGroup.Append>
                                        </InputGroup>
                                    )}
                                </div>
                            </div>
                            <div className="pl-2" style={{marginRight: 30}}>
                                <Button
                                    variant={!ONLINE_PAYMENT_ENABLED ? "secondary" : "primary"}
                                    active={ONLINE_PAYMENT_ENABLED}
                                    disabled={!ONLINE_PAYMENT_ENABLED}
                                    style={!ONLINE_PAYMENT_ENABLED ? disabledPaymentButtonStyle : undefined}
                                    onClick={ONLINE_PAYMENT_ENABLED ? modalHandleOpen : undefined}>
                                    Ödeme Yap
                                </Button>
                            </div>
                        </Row>
                        <Row className="justify-content-end">
                            <div style={{marginRight: 30, marginBottom: 8, maxWidth: 520}}>
                                <OnlinePaymentDisabledNotice style={{marginTop: 0}}/>
                            </div>
                        </Row>

                    </Row>

                </Col>
            </Row>

        );
    }

    if (ready) {
        return (
            <div className="overflow-hidden containerWrapper">
                <Helmet>
                    <title>{helmetTitle}</title>
                </Helmet>
                <Row style={{fontSize: 16}}>
                    <Col lg={12}>
                        <Card>
                            <Card.Header as="h5" style={{height: 85}}
                                         className="align-items-center align-middle p-1 font-weight-bold">
                                <MainHeaderPart tenantName={tenantSubscriptionViewDto.tenantName}
                                                removeCookie={removeCookie}
                                                tabKey={tabKey}/>
                            </Card.Header>
                        </Card>
                    </Col>
                </Row>
                <Tabs
                    className="pt-1 pl-3 tabsColor"
                    id="subscription-tabs"
                    activeKey={tabKey}
                    onSelect={(k) => setTabKey(k)}
                >
                    <Tab eventKey="ahtapot" title="Ahtabot Abonelik">
                        <Col lg={12} style={{padding: 1}}>
                            <Card>
                                <Card.Header as="h5"
                                             className="align-items-center align-middle p-1 font-weight-bold">
                                    <HeaderPart information={tenantSubscriptionViewDto.ahtapotSubscriptionInformation}
                                                warning={!tenantSubscriptionViewDto.hasAhtapotSubscription}
                                                type={"ahtapot"}/>
                                </Card.Header>
                            </Card>
                        </Col>
                        <AhtapotSubscription setCookie={setCookie} removeCookie={removeCookie}
                                             tenantSubscriptionViewDto={tenantSubscriptionViewDto}
                                             viewDto={viewDto}
                                             refreshTab={() => {
                                                 window.location.reload();
                                             }}/>
                    </Tab>
                    <Tab eventKey="payment" title="UGY Abonelik">
                        <div>
                            <Card>
                                <Card.Header as="h5"
                                className="align-items-center align-middle p-1 font-weight-bold">
                                    <Row>
                                    <Col lg={7} style={{"whiteSpace": "nowrap", "padding": "10"}}>
                                {tenantSubscriptionViewDto.userSubscriptionInformation}
                            </Col>
                                </Row>
                                </Card.Header>




                            </Card>
                            <div className="p-3" style={{height:300}}>
                                <CalculationResultPart/>
                            </div>
                        </div>

                        <div style={{display: "flex", padding:"1px"}}>
                            <div style={{
                                width: "20%"
                            }}>
                                <Card>
                                    <Card.Body className="align-items-center align-middle font-weight-bold p-1"
                                               style={{fontSize: 12}}>
                                        <Table striped bordered hover responsive size="sm">
                                            <tbody>
                                            <tr style={{height: 10}}>
                                                <td style={{
                                                    width: "55%"
                                                }}>
                                                </td>
                                                <td style={{
                                                    height: 10,
                                                    "textAlign": "center",
                                                    "verticalAlign": "middle"
                                                }}>
                                                    <Form.Label style={{height: 10}}>
                                                        Adet
                                                    </Form.Label>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <Form.Label className="pt-1 align-middle pl-1" style={{height: 10}}>
                                                        İşlem Yapılan Dosya Sayısı
                                                    </Form.Label>
                                                </td>
                                                <td style={{"textAlign": "end", "verticalAlign": "middle"}}>
                                                    <FormControl
                                                        type='number'
                                                        disabled={true}
                                                        className="text-right align-items-end pl-4"
                                                        style={{fontSize: 10}}
                                                        value={requestDto.activeDosyaCount}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <Form.Label className="pt-1 pl-1 align-middle"
                                                                style={{"whiteSpace": "nowrap"}}>
                                                        İşlem Yapılacak Dosya Sayısı
                                                    </Form.Label>
                                                </td>
                                                <td className="justify-content-end" style={{"whiteSpace": "nowrap"}}>
                                                    <FormControl type='number'
                                                                 className="text-right justify-content-end pl-4"
                                                                 placeholder="Adet"
                                                                 style={{fontSize: 10}}
                                                                 min={defaultTenantProperties && defaultTenantProperties?.defaultUyapDosyaCount ? defaultTenantProperties?.defaultUyapDosyaCount : 0}
                                                                 value={requestDto.openUyapDosyaCount}
                                                                 onChange={onChangeOpenUyapDosyaCount}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <Form.Label className="pt-1 align-middle pl-1">
                                                        TOKEN'lı Avukat Sayısı
                                                    </Form.Label>
                                                </td>
                                                <td>
                                                    <FormControl
                                                        type='number'
                                                        placeholder="Adet"
                                                        className="text-right pl-4"
                                                        style={{fontSize: 10}}
                                                        min={defaultTenantProperties && defaultTenantProperties?.defaultTokenCount ? defaultTenantProperties?.defaultTokenCount : 0}
                                                        value={requestDto.tokenCount}
                                                        onChange={onChangeTokenCount}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <Form.Label className="pt-1 align-middle pl-1">
                                                        Kullanıcı Sayısı
                                                    </Form.Label>
                                                </td>
                                                <td>
                                                    <div className="justify-content-end align-middle ">
                                                        <FormControl
                                                            placeholder="Adet"
                                                            type='number'
                                                            className="text-right align-items-end pl-4"
                                                            style={{fontSize: 10}}
                                                            min={defaultTenantProperties && defaultTenantProperties?.defaultUserCount ? defaultTenantProperties?.defaultUserCount : 0}
                                                            value={requestDto.userCount}
                                                            onChange={onChangeUserCount}
                                                        />
                                                    </div>

                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <Form.Label className="pt-1 align-middle pl-1" style={{height: 10}}>
                                                        Özellik Sayısı
                                                    </Form.Label>
                                                </td>
                                                <td style={{"textAlign": "end", "verticalAlign": "middle"}}>
                                                    <FormControl
                                                        type='number'
                                                        disabled={true}
                                                        className="text-right align-items-end pl-4"
                                                        style={{fontSize: 10}}
                                                        value={featureCount}
                                                    />
                                                </td>
                                            </tr>
                                            </tbody>
                                        </Table>
                                    </Card.Body>
                                </Card>
                            </div>
                            <div style={{
                                width: "45%"
                            }} className="pl-0 pr-0">
                                <Card>
                                    <Card.Body className="p-1">
                                        <div style={{height: "50vh", overflowY: "scroll", border: "black"}}>
                                            <Table striped bordered hover size="sm">
                                                <thead>
                                                <tr style={{"fontSize": 12, "fontWeight": "bold", color: "#00008B"}}>
                                                    <th style={{"fontSize": 12, width: "5%"}}>
                                                        <Form.Check
                                                            type='checkbox'
                                                            custom
                                                            style={{"textAlign": "right", "verticalAlign": "right"}}
                                                            id="selectAllFeaturesId"
                                                            checked={selectAllFeatures}
                                                            onChange={onChangeFeatureAll}
                                                        />
                                                    </th>
                                                    <th style={{
                                                        "verticalAlign": "middle",
                                                        "textAlign": "center",
                                                        "whiteSpace": "nowrap"
                                                    }}>
                                                        Özellik Kategorisi
                                                    </th>
                                                    <th style={{
                                                        "verticalAlign": "middle",
                                                        "textAlign": "center",
                                                        "whiteSpace": "nowrap"
                                                    }}>
                                                        Özellik Adı
                                                    </th>
                                                </tr>
                                                </thead>
                                                <tbody className="align-items-center align-middle">
                                                <GenereateFeature/>
                                                </tbody>
                                            </Table>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </div>
                            <div style={{
                                width: "35%"
                            }} className="pr-3 pl-0">
                                <Card>
                                    <Card.Body className="p-1">
                                        <div style={{height: "50vh", overflowY: "scroll", border: "black"}}>
                                            <Table striped bordered hover responsive size="sm">
                                                <thead>
                                                <tr style={{"fontSize": 12, "fontWeight": "bold", color: "#00008B"}}>
                                                    <th style={{
                                                        "verticalAlign": "middle",
                                                        "textAlign": "center",
                                                        width: "40%",
                                                        "whiteSpace": "nowrap"
                                                    }}>
                                                        Seçilen Özellik Kategorisi
                                                    </th>
                                                    <th style={{
                                                        "verticalAlign": "middle",
                                                        "textAlign": "center",
                                                        width: "60%",
                                                        "whiteSpace": "nowrap"
                                                    }}>
                                                        Seçilen Özellik Adı
                                                    </th>
                                                </tr>
                                                </thead>
                                                <tbody className="align-items-center align-middle">
                                                <GenereateSelectedFeature/>
                                                </tbody>
                                            </Table>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </div>
                        </div>
                        <CalculationButtonsPart/>

                        <Modal centered size='lg' show={modalShow} onHide={modalHandleClose}>
                            <Form>
                                <Modal.Header closeButton>
                                    <Modal.Title>Abonelik Ödeme</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <Row>
                                        <Col className='pb-2' lg={6}>
                                            <Cards
                                                cvc={cardState.cvc}
                                                expiry={cardState.expiry}
                                                focused={cardState.focus}
                                                name={cardState.name}
                                                number={cardState.number}
                                                placeholders={{
                                                    name: 'Ad Soyad'
                                                }}
                                            />
                                        </Col>
                                        <Col lg={5}>
                                            <Form.Row>
                                                <Form.Group as={Col}>
                                                    <InputGroup>
                                                        <InputGroup.Prepend>
                                                            <InputGroup.Text>{getSelectedAccountOption()}</InputGroup.Text>
                                                        </InputGroup.Prepend>
                                                        <NumberFormat value={getSelectedBill(enableDiscountCodeSuccess)}
                                                                      displayType={'text'} thousandSeparator={true}
                                                                      renderText={value =>
                                                                          <Form.Control
                                                                              type='text'
                                                                              style={{
                                                                                  "textAlign": "end",
                                                                                  "verticalAlign": "middle"
                                                                              }}
                                                                              value={value}
                                                                              disabled={true}
                                                                          />}/>
                                                        <InputGroup.Append>
                                                            <InputGroup.Text>TL</InputGroup.Text>
                                                        </InputGroup.Append>
                                                    </InputGroup>
                                                </Form.Group>
                                            </Form.Row>
                                            <Form.Row>
                                                <Form.Group as={Col}>
                                                    <Form.Control
                                                        type='text'
                                                        value={cardState.name}
                                                        onChange={handleCardNameChange}
                                                        placeholder='Kart Üzerindeki İsim'
                                                        isValid={validState.name}
                                                        isInvalid={!validState.name && creditCardValidated}
                                                    />
                                                    <Form.Control.Feedback type="invalid">{}</Form.Control.Feedback>
                                                </Form.Group>
                                            </Form.Row>
                                            <Form.Row>
                                                <Form.Group as={Col}>
                                                    <Form.Control
                                                        type='text'
                                                        value={cardState.number}
                                                        onChange={handleCardNumberChange}
                                                        placeholder='Kart Numarası'
                                                        required
                                                        isValid={validState.number}
                                                        isInvalid={!validState.number && creditCardValidated}
                                                    />
                                                    <Form.Control.Feedback type="invalid">{}</Form.Control.Feedback>
                                                </Form.Group>
                                            </Form.Row>
                                            <Form.Row>
                                                <Form.Group as={Col} lg={8}>
                                                    <Form.Control
                                                        type='text'
                                                        value={cardState.expiry}
                                                        onChange={handleCardExpiryChange}
                                                        placeholder='Son Kullanma Tarihi'
                                                        required
                                                        isValid={validState.expiry}
                                                        isInvalid={!validState.expiry && creditCardValidated}
                                                    />
                                                </Form.Group>
                                                <Form.Group as={Col} lg={4}>
                                                    <Form.Control
                                                        type='text'
                                                        value={cardState.cvc}
                                                        onChange={handleCardCVCChange}
                                                        placeholder='CVC'
                                                        required
                                                        isValid={validState.cvc}
                                                        isInvalid={!validState.cvc && creditCardValidated}
                                                    />
                                                    <Form.Control.Feedback type="invalid">{}</Form.Control.Feedback>
                                                </Form.Group>
                                            </Form.Row>
                                            <Form.Row>
                                                <Form.Group as={Col} lg={12}>
                                                    <Form.Control
                                                        type='text'
                                                        value={cardState.gsm}
                                                        onChange={handleGsmChange}
                                                        placeholder='Cep Telefonu Numarası'
                                                        required
                                                        isValid={validState.gsm}
                                                        isInvalid={!validState.gsm && creditCardValidated}
                                                    />
                                                </Form.Group>
                                            </Form.Row>
                                            <Form.Row>
                                                <Form.Group as={Col} lg={12}>
                                                    <Form.Control
                                                        type="email"
                                                        value={cardState.email}
                                                        onChange={handleEmailChange}
                                                        placeholder='Dekontun İletileceği Mail Adresi'
                                                        required
                                                        isValid={validState.email}
                                                        isInvalid={!validState.email && creditCardValidated}
                                                    />
                                                </Form.Group>
                                            </Form.Row>

                                        </Col>
                                    </Row>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="success" onClick={pay} disabled={paymentProcessing}>
                                        {paymentProcessing ? (<Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                        />) : " Öde"}
                                    </Button>
                                    <Button variant="secondary" onClick={modalHandleClose}>
                                        Kapat
                                    </Button>
                                </Modal.Footer>
                            </Form>
                        </Modal>
                        <Modal centered size='lg' show={secureScreenShow} onHide={secureScreenClose}>
                            <Modal.Header closeButton>
                                <Modal.Title>Abonelik Ödeme</Modal.Title>
                            </Modal.Header>
                            <iframe title="Abonelik Ödeme" className="resp-iframe" src={secureUrl}/>
                            {hasAdminManagement &&
                                <PaymentTestSimulationPanel
                                    payPaymentId={payPaymentId}
                                    onChangePayPaymentId={onChangePayPaymentId}
                                    onSuccessClick={successPayTest}
                                    onErrorClick={errorPayTest}
                                    testProcessing={testProcessing}
                                />
                            }
                        </Modal>

                        <WarningDialog
                            openDialog={validSourceSystemEntegrationOpenDialog}
                            handleAcceptDialog={handleValidSourceSystemEntegrationAcceptDialog}
                            handleCloseDialog={handleValidSourceSystemEntegrationCloseDialog}
                            dialogContentText={"Hiç Bir Kurum İçin Kurum Sistemine Güncelleme Özelliğini Seçmediniz. Kurum Güncelleme İstemediğinize Emin misiniz?"}
                        />

                        <InfoDialog
                            openDialog={infoSourceSystemEntegrationOpenDialog}
                            handleAcceptDialog={handleInfoSourceSystemEntegrationAcceptDialog}
                            handleCloseDialog={handleInfoSourceSystemEntegrationCloseDialog}
                            dialogContentText={selectedSubscriptionFeatureTypeDtoList.filter((item) => {
                                return (!item.disabled && item.enumValue.startsWith('SOURCE_SYSTEM_ENTEGRATION_'))
                            }).map(item => item.name.replace("Kurum Güncelleme ", "")).join(',') +
                            " İçin Kurum Sistemine Güncelleme Seçeneğini Seçtiniz. Kurum Sisteminden İşlem Gerçekleştirebilirsiniz."
                            }
                        />

                        <TooltipDialog
                            open={openTooltipModal}
                            handleClose={handleCloseTooltipModal}
                            title={toolTipTitle}
                            text={toolTipText}
                        />

                    </Tab>
                    <Tab eventKey="history" title="Abonelik/Ödeme Bilgileri Göster">
                        <Row>
                            <div style={{
                                width: "100%",
                                height: "100%"
                            }}>
                                <Card style={{
                                    borderBottom: 0
                                }}>
                                    <Card.Body className="align-items-center align-middle font-weight-bold p-1"
                                               style={{
                                                   width: "100%",
                                                   height: "70vh",
                                                   padding: '0 !important'
                                               }}>
                                        <EtcDataGrid
                                            data={paymentHistoryData}
                                            columns={paymentHistoryColumns}
                                            pageSize={40}/>
                                    </Card.Body>
                                </Card>
                            </div>
                        </Row>

                        <DetailListDialog
                            open={openDetailListDialogModal}
                            handleClose={handleCloseDetailListDialogModal}
                            list={<Table striped bordered hover responsive size="sm">
                                <thead>
                                <tr style={{"fontSize": 12, "fontWeight": "bold", color: "#00008B"}}>
                                    <th style={{
                                        "verticalAlign": "middle",
                                        "textAlign": "center",
                                        width: "40%",
                                        "whiteSpace": "nowrap"
                                    }}>
                                        Seçilen Özellik Kategorisi
                                    </th>
                                    <th style={{
                                        "verticalAlign": "middle",
                                        "textAlign": "center",
                                        width: "60%",
                                        "whiteSpace": "nowrap"
                                    }}>
                                        Seçilen Özellik Adı
                                    </th>
                                </tr>
                                </thead>
                                <tbody className="align-items-center align-middle">
                                <GenereateSelectedFeature/>
                                </tbody>
                            </Table>}
                        />
                    </Tab>
                </Tabs>
                {loginShow ? <Login setCookie={setCookie}/> : null}
            </div>
        );
    } else {
        return (
            <div style={{position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)"}}>
                <Spinner size="lg" animation="border" role="status">
                    <span className="sr-only">Loading...</span>
                </Spinner>
            </div>
        );
    }
}

export default SubscriptionWithPayment;
